/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Lifecycle of an attachment upload. Distinct from @see {@link Synqo.Cloud.Utilities.Enums.Documents.EnumAttachmentScanStatus}:
 * the scan status is one of (currently the only) post-upload processing steps, while this
 * enum tracks the overall flow from "blob being uploaded" to "ready for download".
 */
export enum EnumAttachmentUploadStatus {
    /**
     * Attachment record created, browser is still PUTing the blob to quarantine storage.
     */
    Uploading = 0,
    /**
     * Blob arrived; server-side processing (malware scan, future preview/compression etc.) is running.
     */
    Processing = 1,
    /**
     * All processing steps succeeded; attachment is ready for download.
     */
    Ready = 2,
    /**
     * Any step (validation, scan, processing) failed terminally.
     */
    Failed = 3,
}
